import React, { useState, useEffect } from "react";
import axios from "../axios";
import { useParams } from "react-router-dom";
import moment from "moment-timezone";
import useTasks from "../hooks/useTasks";
import { toast } from "react-toastify";
import {
  Row,
  Col,
  Table,
  FormControl,
  Form,
  Button,
  Alert,
  Modal,
} from "react-bootstrap";
import { TextField } from "@mui/material";

const AjiltanTasks = (props) => {
  const { id, empName } = useParams();
  const [page, setPage] = useState(1);
  const [empTaskCount, setEmpTaskCount] = useState([]);
  const limit = 50;
  const [today, setToday] = useState(
    moment().tz("Asia/Ulaanbaatar").toISOString()
  );
  const [thisWeek, setThisWeek] = useState(
    moment().tz("Asia/Ulaanbaatar").toISOString()
  );

  const todayStart = moment(today)
    .tz("Asia/Ulaanbaatar")
    .startOf("day")
    .utc()
    .toISOString();
  const todayEnd = moment(today)
    .tz("Asia/Ulaanbaatar")
    .endOf("day")
    .utc()
    .toISOString();

  const [thatErrorMessage, setThatErrorMessage] = useState(null);
  const [checkData, setCheckData] = useState(0);
  const [taskId, setTaskId] = useState("");
  const [showZasah, setShowZasah] = useState(false);
  const handleCloseZasah = () => setShowZasah(false);
  const handleShowZasah = () => setShowZasah(true);

  const [daySelectorActive, setDaySelectorActive] = useState({
    day1: true,
    day2: false,
    day3: false,
    day4: false,
    day5: false,
    day6: false,
    day7: false,
  });

  const [employeeTaksData] = useTasks(
    page,
    limit,
    todayStart,
    todayEnd,
    id,
    today,
    thisWeek,
    checkData
  );

  const [employeeData, setEmployeeData] = useState([]);

  const [burtgel, setBurtgel] = useState({
    customer: "",
    note: "",
    arrived: "",
    payment: 0,
    date: moment().tz("Asia/Ulaanbaatar").toISOString(),
    employee: id,
  });

  // Format number with commas for display
  const formatNumber = (num) => {
    if (!num && num !== 0) return "";
    const numStr = num.toString().replace(/,/g, "");
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setThatErrorMessage(null);

    if (name === "payment") {
      // Remove all non-digits
      const numericValue = value.replace(/[^\d]/g, "");
      setBurtgel({
        ...burtgel,
        [name]: numericValue ? parseInt(numericValue) : 0,
      });
    } else {
      setBurtgel({
        ...burtgel,
        [name]: value,
      });
    }
  };

  useEffect(() => {
    const fetchEmployeeTaskCount = async () => {
      const token = localStorage.getItem("salon");

      if (token) {
        try {
          const result = await axios.get(
            `tasks?page=${page}&limit=${limit}&start=${todayStart}&end=${todayEnd}&sort=date`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setEmpTaskCount(result.data.data);
        } catch (error) {
          toast.error(
            `Алдаа: ${error.response?.data?.error?.message || error.message}`
          );
        }
      }
    };

    fetchEmployeeTaskCount();
  }, [page, limit, todayStart, todayEnd]);

  const tsagBurtgeh = async () => {
    if (burtgel.customer === "") {
      toast.warning("Утасны дугаарыг оруулна уу!!");
      return;
    }

    const token = localStorage.getItem("salon");

    try {
      const taskData = {
        ...burtgel,
        payment: parseInt(burtgel.payment) || 0,
        date: moment(burtgel.date).utc().toISOString(),
      };

      const result = await axios.post("tasks", taskData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (result.data.success) {
        toast.success("Бүртгэл амжилттай");
        setCheckData(checkData + 1);

        // Reset form
        setBurtgel({
          customer: "",
          note: "",
          arrived: "",
          payment: 0,
          date: moment().tz("Asia/Ulaanbaatar").toISOString(),
          employee: id,
        });
      } else {
        toast.error("Бүртгэл амжилтгүй боллоо. Дахин оролдоно уу.");
      }
    } catch (error) {
      toast.error(
        `Алдаа: ${error.response?.data?.error?.message || error.message}`
      );
    }
  };

  const NextWeekHandler = () => {
    setThisWeek(moment(thisWeek).add(1, "week").toISOString());
    setDaySelectorActive({
      day1: false,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
    });
  };

  const PrevWeekHandler = () => {
    setThisWeek(moment(thisWeek).subtract(1, "week").toISOString());
    setDaySelectorActive({
      day1: false,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
    });
  };

  const thisDay = () => {
    setThisWeek(moment().tz("Asia/Ulaanbaatar").toISOString());
    setToday(moment().tz("Asia/Ulaanbaatar").toISOString());
    setDaySelectorActive({
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
    });
  };

  const nextPage = () => {
    setPage(page + 1);
  };

  const prevPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const startPage = () => {
    setPage(1);
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      const token = localStorage.getItem("salon");

      if (token) {
        try {
          const result = await axios.get("employees", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setEmployeeData(result.data.data);
        } catch (error) {
          toast.error(
            `Алдаа: ${error.response?.data?.error?.message || error.message}`
          );
        }
      }
    };

    fetchEmployeeData();
  }, []);

  const paginationBasic = (
    <div className="paginationsButtons">
      <Button
        className="paginationStart"
        variant="outline-secondary"
        onClick={() => startPage()}
      >
        Эхний хуудас
      </Button>
      <Button
        className="paginationNext"
        variant="outline-secondary"
        onClick={() => prevPage()}
      >
        Өмнөх
      </Button>
      <span className="paginationPageNumber">{"Хуудас " + page}</span>
      <Button
        className="paginationPrev"
        variant="outline-secondary"
        onClick={() => nextPage()}
      >
        Дараах
      </Button>
    </div>
  );

  const dateExtractor = (userSelectedDate) => {
    let dayEng = moment(userSelectedDate).tz("Asia/Ulaanbaatar").format("dddd");
    const mongoldate = () => {
      if (dayEng === "Monday") return "Даваа";
      if (dayEng === "Tuesday") return "Мягмар";
      if (dayEng === "Wednesday") return "Лхагва";
      if (dayEng === "Thursday") return "Пүрэв";
      if (dayEng === "Friday") return "Баасан";
      if (dayEng === "Saturday") return "Бямба";
      if (dayEng === "Sunday") return "Ням";
    };

    return (
      <div>
        <div className="sMount">
          {moment(userSelectedDate).tz("Asia/Ulaanbaatar").format("MM") +
            " сарын"}
        </div>
        <div className="sDay">
          {moment(userSelectedDate).tz("Asia/Ulaanbaatar").format("DD")}
        </div>
        <div className="ssDay">{mongoldate()}</div>
        <div className="sYear">
          {moment(userSelectedDate).tz("Asia/Ulaanbaatar").format("YYYY")}
        </div>
      </div>
    );
  };

  const updateHandler = async () => {
    const token = localStorage.getItem("salon");

    try {
      const updatedData = {
        ...burtgel,
        payment: parseInt(burtgel.payment) || 0,
        date: moment(burtgel.date).utc().toISOString(),
      };

      await axios.patch(`tasks/${taskId}`, updatedData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Амжилттай заслаа.");
      setCheckData(checkData + 1);
      handleCloseZasah();
    } catch (error) {
      toast.error(
        `Алдаа: ${error.response?.data?.error?.message || error.message}`
      );
    }
  };

  return (
    <div>
      <Modal show={showZasah} onHide={handleCloseZasah}>
        <Modal.Header closeButton>
          <Modal.Title>Цаг бүртгэл засах</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {thatErrorMessage ? (
            <Alert variant="warning" className="mt-2">
              {thatErrorMessage}
            </Alert>
          ) : null}
          <FormControl
            placeholder="Утасны дугаар"
            onChange={handleChange}
            name="customer"
            value={burtgel.customer}
            className="mt-3"
          />
          <FormControl
            placeholder="Тэмдэглэл"
            className="mt-3"
            name="note"
            onChange={handleChange}
            value={burtgel.note}
          />
          <div className="mt-3">Ирсэн эсэх</div>
          <Form.Select
            aria-label="Ирсэн эсэх"
            name="arrived"
            onChange={handleChange}
            value={burtgel.arrived}
          >
            <option value="">Сонгох</option>
            <option value="Тийм">Тийм</option>
            <option value="Үгүй">Үгүй</option>
          </Form.Select>
          <div className="mt-3">Төлбөр</div>
          <FormControl
            placeholder="Төлбөр"
            className="mt-3"
            name="payment"
            onChange={handleChange}
            value={formatNumber(burtgel.payment)}
          />
          <Form.Text className="text-muted">Жишээ: 100,000₮</Form.Text>
          <Form.Select
            aria-label="Хариуцсан ажилтан"
            name="employee"
            onChange={handleChange}
            className="mt-3"
            value={burtgel.employee}
          >
            {employeeData.map((el) => (
              <option value={el._id} key={el._id}>
                {el.name}
              </option>
            ))}
          </Form.Select>
          <div>
            <TextField
              id="datetime-local"
              type="datetime-local"
              className="mt-3"
              value={moment(burtgel.date).format("YYYY-MM-DDTHH:mm")}
              name="date"
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={updateHandler}>
            Засах
          </Button>
          <Button variant="outline-secondary" onClick={handleCloseZasah}>
            Болих
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="mb-3">
        <Row className="daySelectorContainer">
          {[0, 1, 2, 3, 4, 5, 6].map((dayOffset, index) => (
            <Col
              key={`day${index + 1}`}
              className={
                daySelectorActive[`day${index + 1}`]
                  ? "daySelector firstDay"
                  : "daySelector"
              }
              onClick={() => {
                setToday(moment(thisWeek).add(dayOffset, "day").toISOString());
                setDaySelectorActive({
                  day1: false,
                  day2: false,
                  day3: false,
                  day4: false,
                  day5: false,
                  day6: false,
                  day7: false,
                  [`day${index + 1}`]: true,
                });
              }}
            >
              {dateExtractor(
                moment(thisWeek).add(dayOffset, "day").toISOString()
              )}
            </Col>
          ))}
        </Row>

        <div className="filterControllersEmpName">
          <div>
            <Button className="mr15" onClick={PrevWeekHandler}>
              Өмнөх 7 хоног
            </Button>
            <Button className="mr15" onClick={NextWeekHandler}>
              Дараа 7 хоног
            </Button>
            <Button onClick={thisDay}>Өнөөдөр</Button>
          </div>
          <h3>{empName}</h3>
        </div>
      </div>

      <Row>
        <Col md={8}>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Цаг</th>
                <th>Үйлчлүүлэгч</th>
                <th>Ирсэн</th>
                <th>Төлбөр</th>
                <th>Тэмдэглэл</th>
              </tr>
            </thead>
            <tbody>
              {employeeTaksData.map((task) => (
                <tr
                  key={task._id}
                  onClick={() => {
                    handleShowZasah();
                    setTaskId(task._id);
                    setBurtgel({
                      customer: task.customer,
                      note: task.note,
                      arrived: task.arrived,
                      payment: task.payment,
                      date: task.date,
                      employee: task.employee._id || id,
                    });
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <td>{task.date ? moment(task.date).format("HH:mm") : ""}</td>
                  <td>{task.customer}</td>
                  <td>{task.arrived}</td>
                  <td>{formatNumber(task.payment)}₮</td>
                  <td>{task.note}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {paginationBasic}
        </Col>

        <Col md={4} className="p-3 pt-0">
          <div className="tsagburtgehtitle">Цаг бүртгэх</div>
          {thatErrorMessage ? (
            <Alert variant="warning" className="mt-2">
              {thatErrorMessage}
            </Alert>
          ) : null}
          <FormControl
            placeholder="Утасны дугаар"
            onChange={handleChange}
            name="customer"
            value={burtgel.customer}
            className="mt-3"
          />
          <FormControl
            placeholder="Тэмдэглэл"
            className="mt-3"
            name="note"
            onChange={handleChange}
            value={burtgel.note}
          />
          <div className="mt-3">Ирсэн эсэх</div>
          <Form.Select
            aria-label="Ирсэн эсэх"
            name="arrived"
            onChange={handleChange}
            value={burtgel.arrived}
          >
            <option value="">Сонгох</option>
            <option value="Тийм">Тийм</option>
            <option value="Үгүй">Үгүй</option>
          </Form.Select>
          <div className="mt-3">Төлбөр</div>
          <FormControl
            placeholder="Төлбөр"
            name="payment"
            onChange={handleChange}
            value={formatNumber(burtgel.payment)}
          />
          <Form.Text className="text-muted">Жишээ: 100,000₮</Form.Text>

          <div>
            <TextField
              id="datetime-local"
              type="datetime-local"
              className="mt-3"
              value={moment(burtgel.date).format("YYYY-MM-DDTHH:mm")}
              name="date"
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <Button
            onClick={() => tsagBurtgeh()}
            variant="primary"
            className="mt-3 float-right"
          >
            Нэмэх
          </Button>
        </Col>
      </Row>

      <h3 className="mt-4">Тухайн өдрийн ажилтны ачаалал</h3>
      <Row md={5} className="mt-4 mb-4 emptask-container">
        {employeeData.map((ajiltan) => {
          let ajiltanii_tuhain_odriin_task = empTaskCount.filter(
            (elm) => elm.employee?.name === ajiltan.name
          ).length;

          return (
            <Col key={ajiltan._id} className="border p-3 emptask-item">
              <a
                href={`/ajiltan/${ajiltan._id}/${ajiltan.name}`}
                className="m-2"
              >
                <span className="emptask-count-empname">{ajiltan.name}</span>
                <span className="emptask-count-text">
                  {ajiltanii_tuhain_odriin_task}
                </span>
              </a>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default AjiltanTasks;
